export const application = 'bright-dev-v2';

export const apiURL = '/api';

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
